import React, { useEffect, useState } from "react";
import { createTheme } from "@mui/material";
import { ThemeProvider } from "styled-components";
import { Alert, Stack } from "@mui/material";

import { fetchCarrierOptions, fetchCustomerOptions } from "./ReportapiService";
import type { SelectOption } from "./Types";
import { useReport } from "./Usereport";
import ReportFilterBar from "./Reportfilterbar";
import ReportTable from "./Reporttable";
import ServiceTypeToggle from "../../components/shared/ServiceTypeToggle";
import "../../components/CommunicationTemplete/CommunicationTemplate.css";

const defaultTheme = createTheme();

const ReportPage: React.FC = () => {
  const {
    mode,
    setMode,
    filters,
    setFilter,
    reset,
    generate,
    rows,
    loading,
    error,
    hasGenerated,
    canGenerate,
    dateError,
  } = useReport("air");

  const [customerOptions, setCustomerOptions] = useState<SelectOption[]>([]);
  const [carrierOptions, setCarrierOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    fetchCustomerOptions().then(setCustomerOptions);
  }, []);

  // Carriers differ by mode → reload whenever the mode toggle changes.
  useEffect(() => {
    fetchCarrierOptions(mode).then(setCarrierOptions);
  }, [mode]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <div className="ctpl-page-header">
        <div className="ctpl-title-col">
          <h1>Shipment Report</h1>
          <p>Generate air &amp; ocean shipment reports filtered by date, customer, and carrier.</p>
        </div>
        <ServiceTypeToggle
          onTypeChange={(m: "air" | "ocean") => setMode(m)}
          activeTab={mode}
          width="320px"
        />
      </div>

      <ReportFilterBar
        mode={mode}
        filters={filters}
        setFilter={setFilter}
        onGenerate={generate}
        onReset={reset}
        canGenerate={canGenerate}
        dateError={dateError}
        loading={loading}
        customerOptions={customerOptions}
        carrierOptions={carrierOptions}
      />

      {error && (
        <Stack sx={{ mt: 1.5 }}>
          <Alert severity="error">{error}</Alert>
        </Stack>
      )}

      <ReportTable
        mode={mode}
        rows={rows}
        hasGenerated={hasGenerated}
        loading={loading}
        filters={filters}
      />
    </ThemeProvider>
  );
};

export default ReportPage;